import urlParams from './url-params.js';
import './url-params.scss';

export default urlParams;
